import { render, staticRenderFns } from "./terms-and-condition-help-and-support.vue?vue&type=template&id=40aa65e6&"
import script from "./terms-and-condition-help-and-support.vue?vue&type=script&lang=js&"
export * from "./terms-and-condition-help-and-support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports